//
//
//
//
//
//
//
//
//
//
//
//

import UpsellPlusIcon from '~/static/campaigns/upsell-plus-icon.svg?inline';

export default {
  components: {
    UpsellPlusIcon,
  },
  props: {
    upsellCallout: {
      type: Object,
      required: true,
    },
  },
};
